var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7801 16.7206L12.6614 11.6019C13.6529 10.3771 14.2498 8.82089 14.2498 7.12592C14.2498 3.19746 11.0534 0.000976562 7.12491 0.000976562C3.19645 0.000976562 0 3.19742 0 7.12589C0 11.0543 3.19648 14.2508 7.12494 14.2508C8.81991 14.2508 10.3762 13.6538 11.6009 12.6623L16.7196 17.781C16.8658 17.9273 17.0578 18.0008 17.2498 18.0008C17.4419 18.0008 17.6339 17.9273 17.7801 17.781C18.0733 17.4878 18.0733 17.0138 17.7801 16.7206ZM7.12494 12.7508C4.02296 12.7508 1.5 10.2279 1.5 7.12589C1.5 4.0239 4.02296 1.50094 7.12494 1.50094C10.2269 1.50094 12.7499 4.0239 12.7499 7.12589C12.7499 10.2279 10.2269 12.7508 7.12494 12.7508Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c6f91ff8.svg";
export { ForwardRef as ReactComponent };